// extracted by mini-css-extract-plugin
export default {"root":"quoted-tweet-container_root__UCH7j","article":"quoted-tweet-container_article__eprCd"};